<div class="payment-receipt">
  <div class="payment-receipt-header flex-between-center width-100p p-3">
    <p class="m-0 font-bold">Payment recorded</p>
    <i class="fal fa-times close-icon" (click)="closeDialog()"></i>
  </div>

  <div class="payment-receipt-body p-3">
    <div class="flex-center-center success-icon-wrapper">
      <i class="fal fa-check font-600 font-primary p-2 font-18 payment-success-icon"></i>
    </div>

    <div class="amount p-2 br-3 width-100p">
      <div class="flex-between-center width-100p">
        <div class="flex-start-center">
          <i class="fal fa-money-bill font-gray pr-2"></i>
          <span *ngIf="!isPayRix?.data" class="capitalize">{{payment?.paymentType}}</span>
          <span class="capitalize" *ngIf="isPayRix?.data && isPayRix?.data?.length">
            {{payment?.paymentType}}-Online *{{isPayRix?.data[0]?.payment?.number}}</span>
        </div>
        <div>
          <span>{{payment?.amount || 0.00 | currency: usd}}</span>
        </div>
      </div>
    </div>

    <div *ngIf="!isPurchase" class="flex-between-center mt-2">
      <div class="receipt-action amount flex-center-center flex-column p-2 pointer" (click)="handleEmailReceipt()">
        <i class="fal fa-envelope font-16"></i>
        <span>Send receipt</span>
      </div>
      <div class="receipt-action amount flex-center-center flex-column p-2 pointer" (click)="handlePrintReceipt()">
        <i class="fal fa-print font-16"></i>
        <span>
          {{payment?.isPdfUploaded? 'Download': 'View' }} receipt
        </span>
      </div>
    </div>
  </div>

  <div class="payment-receipt-footer flex-between-center width-100p pt-2 pb-2 pl-3 pr-3">
    <span *ngIf="!isPurchase" id="start-new-payment" class="font-primary font-600 font-12 pointer" (click)="startNewPayment()">Start new payment</span>
    <span *ngIf="isPurchase" id="start-new-payment" class="font-primary font-600 font-12 pointer"></span>
    <button id="close-dialog" class="btn btn-save font-12 pointer" (click)="closeDialog()">Close</button>
  </div>
</div>
